import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector } from "react-redux";

export default function Header({ onSkin }) {

  const { user } = useSelector((state) => state.login); 

  console.log("user :", user);
  
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  }

  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);
      onSkin(skin);
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');
      onSkin('');
    }
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear("authToken");
    navigate("/");
  }

  // Get user initials for avatar
  const getInitials = (name) => {
    if (!name) return "SA";
    const names = name.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const currentSkin = localStorage.getItem('skin-mode');
  const isDark = currentSkin === 'dark';

  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      <div className="form-search me-auto bg-white">
        {/* Search input can be added here if needed */}
      </div>

      {/* Theme Toggle */}
      {/* <Dropdown className="dropdown-skin me-3" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <i className="ri-settings-3-line"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <label>Skin Mode</label>
          <nav className="nav nav-skin">
            <Link onClick={skinMode} className={!isDark ? "nav-link active" : "nav-link"}>Light</Link>
            <Link onClick={skinMode} className={isDark ? "nav-link active" : "nav-link"}>Dark</Link>
          </nav>
        </Dropdown.Menu>
      </Dropdown> */}

      {/* User Profile with Name Display */}
      <div className="d-flex align-items-center">
        <div className="user-name-display me-3 d-none d-md-block">
          <div style={{ 
            fontSize: '14px', 
            fontWeight: '600', 
            color: isDark ? '#f3f4f6' : '#111827',
            lineHeight: '1.2'
          }}>
            {user?.name || "Admin"}
          </div>
          {/* <div style={{ 
            fontSize: '11px', 
            color: isDark ? '#9ca3af' : '#6b7280',
            lineHeight: '1'
          }}>
            {user?.role || "Administrator"}
          </div> */}
        </div>

        <Dropdown className="dropdown-profile" align="end">
          <Dropdown.Toggle as={CustomToggle}>
            {/* <div className="avatar online" style={{ position: 'relative' }}> */}

            <div className="avatar" style={{ position: 'relative' }}>
              <div style={{
                width: '38px',
                height: '38px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontWeight: '700',
                fontSize: '14px',
                letterSpacing: '0.5px'
              }}>
                {getInitials(user?.name || "Super Admin")}
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="mt-10-f">
            <div className="dropdown-menu-body">
              <div className="avatar avatar-xl online mb-3" style={{ 
                width: '70px', 
                height: '70px', 
                margin: '0 auto',
                position: 'relative'
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: '800',
                  fontSize: '28px',
                  letterSpacing: '1px'
                }}>
                  {getInitials(user?.name || "Super Admin")}
                </div>
              </div>
              <h5 className="mb-1 text-dark fw-semibold">{user?.name || "Super Admin"}</h5>
              {/* <p className="fs-sm text-secondary">{user?.role || "Administrator"}</p> */}
              {user?.email && (
                <p className="fs-xs text-muted mb-3">{user.email}</p>
              )}

              {/* <nav className="nav">
                <Link to="/profile"><i className="ri-user-line"></i> My Profile</Link>
                <Link to="/account-settings"><i className="ri-settings-4-line"></i> Account Settings</Link>
              </nav> */}
              <hr />
              <nav className="nav">
                {/* <Link to="/help"><i className="ri-question-line"></i> Help Center</Link> */}
                <a onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <i className="ri-logout-box-r-line"></i> Log Out
                </a>
              </nav>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}